<template>
  <!--轮播图 -->
  <div class="head-index-root">
    <van-swipe
      v-if="slideList.length"
      ref="bannerSwipe"
      :key="swipeKey"
      class="my-swipe"
      :autoplay="autoplayMs"
      :loop="slideList.length > 1"
      indicator-color="white"
      style="height: 100%; border-radius: 0.5rem;"
      :show-indicators="showIndicators"
      @change="onSwipeChange"
    >
      <van-swipe-item
        v-for="(item, index) in slideList"
        :key="itemKey(item, index)"
      >
        <van-image
          :lazy-load="!isGifUrl(item.showImgId.showImg)"
          :src="item.showImgId.showImg"
          fit="cover"
          alt=""
          class="img"
          @click="onBannerClick(item)"
        />
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import { ImagePreview } from 'vant';
import { queryAndNavigateHotShow, markHomeLeaveForH5 } from '@/utils/categoryNav';
import { isGifUrl } from '@/utils/image';

export default {
  name: 'indexHead',
  props: {
    headData: {
      type: Array,
      default: () => [],
    },
    showIndicators: {
      type: Boolean,
      default: true,
    },
    formContext: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      currentIndex: 0,
    }
  },
  computed: {
    slideList() {
      return (this.headData || []).filter(
        (item) => item && item.showImgId && item.showImgId.showImg
      );
    },
    autoplayMs() {
      return this.slideList.length > 1 ? 5000 : 0;
    },
    swipeKey() {
      return this.slideList
        .map((item) => item.showImgId.id != null ? item.showImgId.id : item.showImgId.showImg)
        .join('-');
    },
  },
  watch: {
    slideList: {
      handler(list) {
        this.$nextTick(() => {
          this.resizeSwipe()
          if (list && list.length) {
            this.emitBannerChange(0)
          }
        })
      },
      deep: true,
    },
  },
  mounted() {
    this.$nextTick(() => this.resizeSwipe());
  },
  activated() {
    this.$nextTick(() => {
      this.resizeSwipe()
      this.syncCurrentBanner()
    })
  },
  methods: {
    isGifUrl,
    itemKey(item, index) {
      const id = item.showImgId && item.showImgId.id;
      return id != null ? id : index;
    },
    resizeSwipe() {
      const swipe = this.$refs.bannerSwipe;
      if (swipe && typeof swipe.resize === 'function') {
        swipe.resize();
      }
    },
    /** showType=6 纯图通知：点击放大预览，不跳转、不 Toast */
    previewPureBanner(item) {
      const url = item && item.showImgId && item.showImgId.showImg;
      if (!url) return;
      ImagePreview({
        images: [url],
        closeable: true,
      });
    },
    onBannerClick(item) {
      // 纯图通知优先处理，避免走 clickable=false 的「敬请期待」
      if (item && String(item.showType) === '6') {
        this.previewPureBanner(item);
        return;
      }
      if (item && item.clickable === false) {
        if (this.$Toast) {
          this.$Toast('敬请期待');
        }
        return;
      }
      queryAndNavigateHotShow(this, item, {
        hotType: 'A',
        listHotType: 'A',
        formOverrides: this.formContext,
        onBeforeH5Leave: () => this.saveHomeScrollBeforeLeave(),
      });
    },
    saveHomeScrollBeforeLeave() {
      let parent = this.$parent;
      while (parent) {
        if (parent.$refs && parent.$refs.category) {
          markHomeLeaveForH5(parent.$refs.category.current || 0);
          return;
        }
        parent = parent.$parent;
      }
      markHomeLeaveForH5(0);
    },
    onSwipeChange(index) {
      this.currentIndex = index
      this.emitBannerChange(index)
    },
    getActiveIndex() {
      const swipe = this.$refs.bannerSwipe
      if (swipe && typeof swipe.active === 'number') {
        return swipe.active
      }
      return this.currentIndex
    },
    /** 与当前轮播帧对齐主题色（从搜索页返回等场景） */
    syncCurrentBanner() {
      const index = this.getActiveIndex()
      this.currentIndex = index
      this.emitBannerChange(index)
    },
    emitBannerChange(index) {
      const item = this.slideList[index]
      if (!item) return
      this.$emit('banner-change', { index, item })
    },
  },
};
</script>

<style lang="scss" scoped>
.head-index-root {
  width: 100%;
  height: 100%;
}

.img {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  background-color: black;
}
</style>
